<template><div><h1 id="anonymisierung-fremdadresse" tabindex="-1"><a class="header-anchor" href="#anonymisierung-fremdadresse"><span>Anonymisierung (Fremdadresse)</span></a></h1>
<p>Anonymisierung (Fremdadresse) — Job für die Anonymisierung einer einzelnen Fremdadresse</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Bei dieser Anonymisierung werden die Fremdadressen gelöscht und ihre -Ereignisse zu der Fremdadresse &quot;Anonym (Sammeladresse)&quot; verschoben.</p>
<h2 id="start-parameter" tabindex="-1"><a class="header-anchor" href="#start-parameter"><span>Start &amp; Parameter</span></a></h2>
<p>Pfad: Personen: → Fremdadressen → Menü: Fremdadresse anonymisieren</p>
<p><strong>Parameter</strong></p>
<dl>
<dt>anonymisieren (Checkbox)</dt>
<dd>Freigabe zur Anonymisierung</dd>
</dl>
<h2 id="welche-daten-werden-verandert-oder-erzeugt" tabindex="-1"><a class="header-anchor" href="#welche-daten-werden-verandert-oder-erzeugt"><span>Welche Daten werden verändert oder erzeugt?</span></a></h2>
<div class="hint-container warning">
<p class="hint-container-title">Achtung</p>
<p>Es werden Daten gelöscht und anonymisiert. Dieser Prozess kann nicht wieder rückgängig gemacht werden!</p>
</div>
<p>Die Fremdadressereignisse werden zu &quot;Anonym (Sammeladresse)&quot; verschoben. Diese Adresse ist im Systemparameter &quot;GDPR&quot; definiert.</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/datenschutz/datenschutz.html" title="Kapitel 9. Datenschutz">Datenschutz</RouteLink></p>
</div></template>


